<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div
        :style="{ width: headers[0].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
        <!--        {{ item.plan?.plan_master?.plan_code }}-->
      </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          style="height: 20px"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
        >
          <tooltip-text :text="item?.plan?.plan_master?.plan_name_th" />
        </div>
        <div
          v-if="
            item.plan?.main_project?.start_date &&
            item.plan?.main_project?.end_date
          "
          class="one-line font-type-normal"
          style="height: 20px"
        >
          <tooltip-text
            :text="
              toDateRangeFormat(
                item.plan.main_project.start_date,
                item.plan.main_project.end_date
              )
            "
          />
        </div>
        <div class="one-line font-type-normal" style="height: 20px">
          <tooltip-text
            :text="
              'หน่วยงานรับรองจนถึงวันที่ ' +
              toDateFormat(item.plan.main_project.consider_date)
            "
          />
        </div>
      </div>
      <div :style="{ width: headers[2].width }">
        <div class="one-line mb-5">
          {{ item.region }}
        </div>
        <div class="one-line font-type-normal" style="height: 20px">
          ปีงบประมาณ {{ item.plan?.main_project?.fiscal_year }}
        </div>
      </div>
      <div
        :style="{
          width: headers[3].width,
          color: statusColorSeparator(item.status),
        }"
      >
        <!--        TODO: change to condition between Submitted & Considered-->
        <div v-if="item.owned_evaluated == null || (item.owned_evaluated && item.owned_evaluated.status === 'Draft')" class="d-flex gap-8">
          <Button height="36px" @onClick="toEvaluateForm(item.id)">
            พิจารณา
          </Button>
        </div>
        <div v-else>
          <Button
            height="36px"
            theme="7"
            @onClick="toEvaluateView(item.owned_evaluated.id)"
          >
            พิจารณาเสร็จสิ้น
          </Button>
        </div>
      </div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex flex-row">
          <b>หลักการและเหตุผล</b>
        </div>
        <div class="d-flex flex-row mt-2">
          {{ item.plan?.principle }}
        </div>
        <v-divider class="my-3"></v-divider>

        <div class="flex-row">
          <div class="d-flex justify-space-between gap-12 theme-color-eight">
            <div style="min-width: 10%; max-width: 10%">จัดการ</div>
            <div style="min-width: 8%; max-width: 8%">ลำดับ</div>
            <div style="min-width: 45%; max-width: 45%">ชื่อโครงการ</div>
            <div style="min-width: 10%; max-width: 10%">รอบเปิดรับ</div>
            <div style="min-width: 10%; max-width: 10%">มหาวิทยาลัย</div>
            <div style="min-width: 10%; max-width: 10%">ผู้นำเข้าข้อมูล</div>
          </div>
          <v-divider class="my-3"></v-divider>
          <div
            v-if="item.kpi_annex_project.length > 0"
            class="d-flex flex-column gap-8"
          >
            <div v-for="(x, i) in item.kpi_annex_project" :key="i">
              <div class="d-flex justify-space-between align-center gap-12">

                <div style="min-width: 10%; max-width: 10%">
                  <v-btn small icon @click="onPreview(x.form_c?.id)">
                    <Iconify icon="carbon:view-filled" size="15px"></Iconify>
                  </v-btn>
                </div>

                <div style="min-width: 8%; max-width: 8%">
                  {{ i + 1 }}
                </div>

                <div
                  style="
                    min-width: 45%;
                    max-width: 45%;
                    text-overflow: ellipsis;
                  "
                >
                  <tooltip-text
                    :text="
                      x.form_c?.project_section_general_info?.project_name_th ||
                      x.form_c?.project_section_general_info?.lab_name
                    "
                  />
                </div>
                <div style="min-width: 10%; max-width: 10%">
                  รอบที่ {{ x.form_c?.project_accept_round?.round }}
                </div>
                <div style="min-width: 10%; max-width: 10%">
                  <tooltip-text :text="x.form_c?.university?.name_th" />
                </div>
                <div style="min-width: 10%; max-width: 10%">
                  <tooltip-text :text="x?.form_c?.created_by" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-center gap-12 mt-6">
          <Button @onClick="viewFormB(item.id)"> ดูโครงการ </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat, toDateFormat } from "../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "EvaluateListItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      toDateFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
    };
  },
  computed: {},
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Submitted1":
        case "Submitted2":
        case "Inception":
          this.theme = 5;
          return "#000";

        case "Approved":
          this.theme = 3;
          return "var(--theme-color-three)";

        default:
          return "#000";
      }
    },
    viewFormB(id) {
      //TODO: change to view page
      // open in new tab
      // this.$router.push({ name: "FormB", query: { id: id, preview: true } });
      const routeData = this.$router.resolve({
        name: "FormB",
        query: { id: id, preview: true, redirect: "EvaluateList" },
      });
      window.open(routeData.href, "_blank");
    },
    toEvaluateForm(id) {
      this.$router.push({ name: "EvaluateForm", params: { 
        id: id,
        formType: 'form-b'
       } });
    },
    toEvaluateView(id) {
      this.$router.push({ name: "EvaluateView", params: { id: id } });
    },
    onPreview(id) {
      console.log(id)
      this.$router.push({ path: `/project-c-form?id=${id}&preview=true` });
    },
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
